export default "__VITE_ASSET__zZUciWSa__"